export const FreeTrialButton = () => {
  return (
    <a
      href={
        process.env.NEXT_PUBLIC_DIST_ENV === "production"
          ? "https://pro.lawfully.com/sign-up"
          : "https://pro-test.lawfully.com/sign-up"
      }
      css={`
        width: 100%;

        @media (min-width: 960px) {
          width: fit-content;
        }
      `}
      target="_blank"
      rel="noreferrer"
      tabIndex={-1}
    >
      <button
        css={`
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 52px;
          padding: 16px 24px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(90deg, #325aff -10.91%, #7a05f6 134.57%);
          color: #fff;
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
          font-family: "Pretendard", sans-serif;
          cursor: pointer;
          transition: opacity 120ms cubic-bezier(0.5, 1, 0.89, 1);

          :hover {
            opacity: 0.9;
          }
        `}
      >
        Start 14-day free trial
      </button>
    </a>
  );
};
